<section class="container mt-5">

    <div class="row">
        <div class="col-12">
    <h2>Todos los adicionales del {{evento?.nombre}}</h2>
    <button class="btn btn-success" routerLink="/administradores/admin/eventos/lista">Atras</button>
    <div *ngIf ='message' class="alert alert-success ">{{message}}</div>
    <div class="container">
    <table class="table mt-3">

        <thead>
            <tr>
                <th>Id</th>
                <th>Nombre</th>
                <th>Precio</th>
                <th>Servicio</th>
                <th>ServicioIva</th>
                <th>Total</th>
                                
            </tr>
    
    
    
        </thead>
        <tbody>
          
  
    
    
        </tbody>
    
    </table>
</div>
<div class="row">
    <div class="col-12 mt-5" style="text-align: center;">
<button  routerLink="agregar" class="btn btn-success">Agregar Adicional</button>

</div>
</div>
</div>
</div>
</section>